window.addEventListener('DOMContentLoaded', function () {
    let feature_posts_slider = document.querySelectorAll('.js-service-slider.splide');

    if (feature_posts_slider.length > 0) {
        for (let i = 0; i < feature_posts_slider.length; i++) {
            let splide = new Splide(feature_posts_slider[i], {
                type: 'loop',
                rewind: true,
                gap: 0,
                arrows: false,
                pagination: false,
                autoWidth: true,
                perMove: 1,
                snap: true,
                drag: 'free',
                breakpoints: {
                    578: {
                        fixedWidth: '100%',
                        perPage: 1,
                        padding: {
                            right: 50
                        },
                    }
                }
            }).mount();
        }
    }
});
